export const insuranceProviders = ['cover_genius', 'nib'];
